/**
 * Admin-only routes — clinic finances, settings, marketing, billing, audit,
 * inventory, etc. Restricted to role=admin (platform_admin also allowed via
 * the Protected wrapper's superuser bypass).
 */
import React from 'react';
import { Route } from 'react-router-dom';
import AdminServices from '../pages/admin/AdminServices';
import AdminClinicians from '../pages/admin/AdminClinicians';
import AdminClinicianHours from '../pages/admin/AdminClinicianHours';
import AdminHR from '../pages/admin/AdminHR';
import AdminReviews from '../pages/admin/AdminReviews';
import AdminAudit from '../pages/admin/AdminAudit';
import AdminFinances from '../pages/admin/AdminFinances';
import AdminMarketing from '../pages/admin/AdminMarketing';
import AdminInvite from '../pages/admin/AdminInvite';
import AdminUsers from '../pages/admin/AdminUsers';
import AdminInventory from '../pages/admin/AdminInventory';
import AdminMemberships from '../pages/admin/AdminMemberships';
import AdminStudents from '../pages/admin/AdminStudents';
import AdminReports from '../pages/admin/AdminReports';
import AdminThemes from '../pages/admin/AdminThemes';
import AdminSettings from '../pages/admin/AdminSettings';
import AdminSystemStatus from '../pages/admin/AdminSystemStatus';
import AdminBrandPreview from '../pages/admin/AdminBrandPreview';
import AdminTreatmentPackages from '../pages/admin/AdminTreatmentPackages';
import AdminHepVideos from '../pages/admin/AdminHepVideos';
import AdminHepPrograms from '../pages/admin/AdminHepPrograms';
import AdminEducation from '../pages/admin/AdminEducation';
import AdminBilling from '../pages/admin/AdminBilling';
import AdminDataMigration from '../pages/admin/AdminDataMigration';
import AdminCompliance from '../pages/admin/AdminCompliance';
import AdminTimeOff from '../pages/admin/AdminTimeOff';
import AdminFitnessAddon from '../pages/admin/AdminFitnessAddon';
import AdminMassageIntakeAddon from '../pages/admin/AdminMassageIntakeAddon';
import Storefront from '../pages/Storefront';

export const adminOnlyRoutes = (
  <>
    <Route path="/admin/services" element={<AdminServices />} />
    <Route path="/admin/clinicians" element={<AdminClinicians />} />
    <Route path="/admin/clinician-hours" element={<AdminClinicianHours />} />
    <Route path="/admin/hr" element={<AdminHR />} />
    <Route path="/admin/reviews" element={<AdminReviews />} />
    <Route path="/admin/audit" element={<AdminAudit />} />
    <Route path="/admin/finances" element={<AdminFinances />} />
    <Route path="/admin/marketing" element={<AdminMarketing />} />
    <Route path="/admin/invite" element={<AdminInvite />} />
    <Route path="/admin/users" element={<AdminUsers />} />
    <Route path="/admin/inventory" element={<AdminInventory />} />
    <Route path="/admin/memberships" element={<AdminMemberships />} />
    <Route path="/admin/students" element={<AdminStudents />} />
    <Route path="/admin/reports" element={<AdminReports />} />
    <Route path="/admin/themes" element={<AdminThemes />} />
    <Route path="/admin/store" element={<Storefront />} />
    <Route path="/admin/settings" element={<AdminSettings />} />
    <Route path="/admin/system-status" element={<AdminSystemStatus />} />
    <Route path="/admin/billing" element={<AdminBilling />} />
    <Route path="/admin/data-migration" element={<AdminDataMigration />} />
    <Route path="/admin/compliance" element={<AdminCompliance />} />
    <Route path="/admin/brand-preview" element={<AdminBrandPreview />} />
    <Route path="/admin/treatment-packages" element={<AdminTreatmentPackages />} />
    <Route path="/admin/hep" element={<AdminHepVideos />} />
    <Route path="/admin/hep/programs" element={<AdminHepPrograms />} />
    <Route path="/admin/education" element={<AdminEducation />} />
    {/* Iter 116 — Admin approvals for clinician-submitted time-off requests. */}
    <Route path="/admin/time-off" element={<AdminTimeOff />} />
    {/* Iter 131 — Fitness add-on purchase / request page (owner). */}
    <Route path="/admin/fitness-addon" element={<AdminFitnessAddon />} />
    {/* Iter 132 — Massage Intake add-on purchase / request page (owner). */}
    <Route path="/admin/massage-intake-addon" element={<AdminMassageIntakeAddon />} />
  </>
);
